import { t } from "@/i18n-js/instance";
import { planFeatures } from "@/react/helpers/plansHelpers";

import { PlanFeatureFlag } from "./../PlanFeatureFlag";
import { SectionWrapper } from "./SectionWrapper";

export const Workflows = () => (
  <SectionWrapper sectionName={t("pricing_plans.section.workflows")}>
    <PlanFeatureFlag
      title={t("pricing_plans.feature.workflows.automations")}
      feature={planFeatures.max_dynamic_workflows_count}
    />
    <PlanFeatureFlag
      title={t("pricing_plans.feature.workflows.scheduled_workflows")}
      feature={planFeatures.max_scheduled_workflows_count}
    />
    <PlanFeatureFlag
      title={t("pricing_plans.feature.workflows.bulk_actions")}
      feature={planFeatures.max_bulk_action_workflows_count}
      suffix={t("pricing_plans.per_month")}
    />
  </SectionWrapper>
);
